import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

//Imgs
import HeaderImage from "../../Global/images/assessmentTeam.png";
import { ReactComponent as CubeIcon } from "../../Global/icons/cube.svg";
import { ReactComponent as PuzzleIcon } from "../../Global/icons/PuzzleIcon.svg";

const StyledAssessmentHeader = styled(NanoFlex)`
  height: auto;
  width: 100%;

  .paddingBlock {
    height: auto;
    gap: 30px;
  }

  .headerImage {
    overflow: hidden;
    border-radius: 10px;
    height: 100%;
    position: relative;
    height: 620px;
    width: 60%;
    background-color: ${(props) => props.theme.color.primaryColors.transparencyPurple};

    img {
      position: absolute;
      min-height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  .headerContent {
    overflow: hidden;
    border-radius: 10px;
    background-color: ${(props) => props.theme.color.primaryColors.lighterPurple};
    height: 620px;
    padding: 52px 100px 52px 100px;
    width: 40%;
    gap: 24px;
    position: relative;

    h5 {
      text-transform: none;
    }

    h3 {
      font-weight: 500;
      color: ${(props) => props.theme.color.primaryColors.darkPurple};
    }

    .headerIcon {
      top: 16px;
      left: 100px;
      height: auto;
      width: auto;
      flex-grow: 1;

      svg {
        height: 70px;
        width: auto;
      }
    }
  }

  @media only screen and (max-width: 1450px) {
    height: 400px;

    .paddingBlock {
      .headerImage {
        height: 400px;
      }

      .headerContent {
        height: 400px;
        padding: 56px 50px 56px 50px;
        gap: 16px;

        .headerIcon {
          left: 50px;
        }
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    min-height: auto;
    height: auto;

    .paddingBlock {
      .headerImage {
        height: 350px;
        width: 60%;
      }

      .headerContent {
        height: 350px;
        padding: 36px 30px 36px 30px;
        width: 40%;
        .headerIcon {
          left: 30px;

          svg {
            height: 50px;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 815px) {
    height: auto;
    min-height: auto;

    .paddingBlock {
      flex-direction: column;
      .headerContent {
        width: 100%;
        height: auto;
        min-height: unset;
        border-radius: 5px;
        padding: 16px 10px 16px 10px;

        .headerIcon {
          top: 8px;
          left: 10px;

          svg {
            height: 50px;
            width: auto;
          }
        }
      }

      .headerImage {
        max-height: 332px;
        min-height: unset;
        height: 332px;
        width: 100%;
        border-radius: 5px;
        display: none;
      }
    }
  }
`;

export default class AssessmentHeader extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledAssessmentHeader className="assessmentHeader" alignItems={"flex-start"}>
        <NanoFlex className="paddingBlock">
          <NanoFlex className="headerContent" flexDirection="column" alignItems="flex-start">
            <NanoFlex className="headerIcon" justifyContent="flex-start" alignItems="flex-start">
              <PuzzleIcon />
            </NanoFlex>
            <Type.h5>
              Assessment <br /> & Development Center
            </Type.h5>
            <Type.h3>{this.translation.assessment.teamPotential}</Type.h3>
          </NanoFlex>
          <NanoFlex className="headerImage">
            <img src={HeaderImage} alt="assessment team" />
          </NanoFlex>
        </NanoFlex>
      </StyledAssessmentHeader>
    );
  }
}
